import React from 'react';
import {Button} from 'react-bootstrap'
export default (props) => {
    return (
        <div>
            {props.list && props.list.map(element => 
              <Button 
                onClick={ () => props.selectItem(props.type, element.id ? element.id : element.sequence)} 
                style={{...props.style, border:"none", margin:"0.1em", width:"32%"}} 
                key={element.name ? element.name : element.sequence}>{element.name ? element.name : element.checkPoint.name ? element.checkPoint.name : element.sequence}</Button>  
            )}
        </div>
    );
}